import { render } from "./CryptoLogo.vue?vue&type=template&id=74d0f5a0"
import script from "./CryptoLogo.vue?vue&type=script&lang=js"
export * from "./CryptoLogo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__